import Store from "@/store/index.js";
import axios from 'axios';
const domain = Store.state.domain;

export default {
    async ExpedientesConcluidosExcel(mes, anio) {
        var formData = new FormData();
        formData.append("mes", mes);
        formData.append("anio", anio);
        let response = await axios.post(`${domain.domainNameForApi}Utilidades/ExpedientesConcluidosExcel`, formData);
        return response.data;
    },
    obtenerTipoCita(vm) {
        vm.axios.post(`${vm.domain.domainNameForApi}ControldeCitas/ObtenerTipoCita`).then(response => {
            vm.tipoCita.opcionesCita = response.data;
        })
    },
    ObtenerEstatus(vm) {
        vm.axios.post(`${vm.domain.domainNameForApi}ControldeCitas/ObtenerEstatus`).then(response => {
            vm.tipoEstatus.opcionesEstatus = response.data;
        })
    },
    async CitasReportesExcel(fechainicio, fechafin, estatus, tipo) {
        var formData = new FormData();
        formData.append("fhcita", fechainicio);
        formData.append("fhfincita", fechafin);
        formData.append("estatus", estatus);
        formData.append("tipo", tipo);

        let response = await axios.post(`${domain.domainNameForApi}Utilidades/CitasReportesExcel`, formData);
        return response.data;
    },
    async ObtenerClientes() {
        let response = await axios.post(`${domain.domainNameForApi}Utilidades/ObtenerClientes`);
        return response.data;
    },
    async AltaReasignacion(datosReasignacion) {
        let response = await axios.post(`${domain.domainNameForApi}Utilidades/AltaReasignacion`, datosReasignacion);
        return response.data;
    },

    async ObtenerProductos(clclave) {
        var formData = new FormData();
        formData.append("clclave", clclave);
        let response = await axios.post(`${domain.domainNameForApi}Utilidades/ObtenerProductos`, formData);
        return response.data;
    },
    async ObtenerObservacionesProducto(clclave, producto) {
        var formData = new FormData();
        formData.append("cliente", clclave);
        formData.append("cveproducto", producto);
        let response = await axios.post(`${domain.domainNameForApi}Utilidades/ObtenerObservacionesProducto`, formData);
        return response.data;
    },
    AlmacenarVisitas(datos) {
        return axios.post(`${domain.domainNameForApi}Documentos/AlmacenarVisitas`, datos).then(response => response.data);
    },
    //async GuardarSeguimento(datas) {
    //    return await axios.post(`${domain.domainNameForApi}Operacion/GuardarSeguimento`, datas).then(response => response.data);
    //},
    EliminarSeguimiento(datas) {
        return axios.post(`${domain.domainNameForApi}Operacion/EliminarSeguimiento`, datas).then(response => response.data);
        //return response.data;
    },
    GuardarSeguimento(datos) {
        return axios.post(`${domain.domainNameForApi}Operacion/GuardarSeguimento`, datos).then(response => response.data);
    },
    GuardarSeguimentoAtlas(datos) {

        return axios.post(`${domain.domainNameForApi}Operacion/GuardarSeguimentoAtlas`, datos).then((response) => response.data.result);
    },
    GuardarSeguimientoArchivo(datos) {
        return axios.post(`${domain.domainNameForApi}Operacion/GuardarSeguimientoArchivo`, datos).then((response) => response.data);
    },
    EliminarArchivo(datos) {
        return axios.post(`${domain.domainNameForApi}Operacion/EliminarArchivo`, datos).then((response) => response.data);
    },
    ArchivosAtlasEnvio(datos) {
        return axios.post(`${domain.domainNameForApi}Operacion/ArchivosAtlasEnvio`, datos).then((response) => response.data);
    },
    async ObtenerConcluidos() {
        let response = await axios.post(`${domain.domainNameForApi}Utilidades/Concluidos`);
        return response.data;
    },
    BitacoraEnvio(datos) {
        return axios.post(`${domain.domainNameForApi}Operacion/BitacoraEnvio`, datos).then((response) => response.data);
    },
    ObservacionesExpediente(data) {
        //return vm.axios.post(`${vm.domain.domainNameForApi}Operacion/ObservacionesExpediente`, data).then(response => response.data);
        return axios.post(`${domain.domainNameForApi}Operacion/ObservacionesExpediente`, data).then((response) => response.data);
    },
}